import { render, staticRenderFns } from "./gptAssistant.vue?vue&type=template&id=0c696228&"
import script from "./gptAssistant.vue?vue&type=script&lang=js&"
export * from "./gptAssistant.vue?vue&type=script&lang=js&"
import style0 from "./gptAssistant.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports